module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("申请人")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.staffName))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("所在部门")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.staffDeptName))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("行政级别")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.info.rankName))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "detail-page-title",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("申请信息")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("申请加班处理"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('cell-box', {
    attrs: {
      "is-link": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openPopup($event)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.selectItem) + "\n          ")])], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("申请加班时间"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('flexbox', {
    attrs: {
      "gutter": 0,
      "wrap": "wrap"
    }
  }, [_c('flexbox-item', {
    attrs: {
      "span": 1 / 2
    }
  }, [_c('a', {
    staticClass: "chooseDate",
    on: {
      "click": _vm.chooseStartDate
    }
  }, [_vm._v("\n                " + _vm._s(_vm.startDate) + "\n                "), _c('img', {
    staticClass: "icon right",
    attrs: {
      "src": require("../../../assets/icon/date-blue.png"),
      "width": "18",
      "height": "18"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v("~")])])]), _vm._v(" "), _c('flexbox-item', {
    attrs: {
      "span": 1 / 2
    }
  }, [_c('a', {
    staticClass: "chooseDate",
    staticStyle: {
      "padding-left": "15px"
    },
    on: {
      "click": _vm.chooseEndDate
    }
  }, [_vm._v("\n                " + _vm._s(_vm.endDate) + "\n                "), _c('img', {
    staticClass: "icon right",
    staticStyle: {
      "right": "5px"
    },
    attrs: {
      "src": require("../../../assets/icon/date-blue.png"),
      "width": "18",
      "height": "18"
    }
  })])])], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("加班天数")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.dateDiffer) + "\n        ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("加班事由"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('x-textarea', {
    attrs: {
      "max": 200,
      "show-counter": false,
      "height": 50,
      "rows": 4,
      "cols": 30,
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.overtimeReason),
      callback: function($$v) {
        _vm.overtimeReason = $$v
      },
      expression: "overtimeReason"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("备注")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('x-textarea', {
    attrs: {
      "max": 200,
      "show-counter": false,
      "height": 50,
      "rows": 4,
      "cols": 30,
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.remark),
      callback: function($$v) {
        _vm.remark = $$v
      },
      expression: "remark"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('popup', {
    model: {
      value: (_vm.selectModelFlag),
      callback: function($$v) {
        _vm.selectModelFlag = $$v
      },
      expression: "selectModelFlag"
    }
  }, [_c('popup-header', {
    attrs: {
      "title": _vm.selectModelTitle,
      "show-bottom-border": false
    }
  }), _vm._v(" "), _c('group', {
    attrs: {
      "gutter": "0"
    }
  }, [_c('radio', {
    attrs: {
      "options": _vm.selectModelData
    },
    on: {
      "on-change": _vm.getType
    },
    model: {
      value: (_vm.selectModel),
      callback: function($$v) {
        _vm.selectModel = $$v
      },
      expression: "selectModel"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e951165e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/launch/attendance/overtimeApply.vue
// module id = px1d
// module chunks = 0